import { render, staticRenderFns } from "./ModalPushNotificationsHelper.vue?vue&type=template&id=cd46bb24&scoped=true&"
import script from "./ModalPushNotificationsHelper.vue?vue&type=script&lang=ts&"
export * from "./ModalPushNotificationsHelper.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPushNotificationsHelper.vue?vue&type=style&index=0&id=cd46bb24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd46bb24",
  null
  
)

export default component.exports